/**
 * List of country codes supported by Stripe Connect
 * Source: https://stripe.com/global
 */
export const STRIPE_SUPPORTED_COUNTRIES = [
    'US', // United States
    'AU', // Australia
    'AT', // Austria
    'BE', // Belgium
    'BG', // Bulgaria
    'CA', // Canada
    'CY', // Cyprus
    'CZ', // Czech Republic
    'DK', // Denmark
    'EE', // Estonia
    'FR', // France
    'FI', // Finland
    'DE', // Germany
    'GR', // Greece
    'HK', // Hong Kong
    'HU', // Hungary
    'IE', // Ireland
    'IT', // Italy
    'JP', // Japan
    'LV', // Latvia
    'LT', // Lithuania
    'LU', // Luxembourg
    'MT', // Malta
    'NL', // Netherlands
    'NZ', // New Zealand
    'NO', // Norway
    'PL', // Poland
    'PT', // Portugal
    'RO', // Romania
    'SG', // Singapore
    'SK', // Slovakia
    'SI', // Slovenia
    'ES', // Spain
    'SE', // Sweden
    'CH', // Switzerland
    'GB', // United Kingdom
    'AE', // United Arab Emirates
];
